import * as React from 'react';
import { Path, Svg } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <Path
            d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM11.0811 6.39941C10.6011 5.55992 9.39104 5.55992 8.91113 6.39941L6.06445 11.3809C5.58841 12.2142 6.19067 13.251 7.15039 13.251H12.8418C13.8015 13.251 14.4038 12.2142 13.9277 11.3809L11.0811 6.39941Z"
            fill={ds.colorValue.icon.success}
        />
    </Svg>
);

export default SvgComponent;
